import { SvgLogo } from "ui/svgs";

export default function PresetList({
  presetList,
  selectedPresetId,
  onChangeSelectedPresetId,
}) {
  return (
    <div
      style={{
        marginTop: "12px",
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "8px",
        overflow: "auto",
        maxHeight: "270px",
      }}
    >
      {presetList?.map((preset, index) => {
        let selected = false;
        if (selectedPresetId === preset?.id) {
          selected = true;
        }
        let homePreset = false;
        if (index === 0) {
          homePreset = true;
        }
        return (
          <div
            style={{ position: "relative" }}
            onClick={() => onChangeSelectedPresetId(preset.id)}
          >
            {preset.snapshot ? (
              <img
                src={preset.snapshot}
                className="aspect-video "
                style={{
                  width: "100%",
                  maxWidth: "350px",
                  borderRadius: "8px",
                  border: selected
                    ? "3px solid rgba(62, 131, 246, 1)"
                    : "1px solid #E1E1E1",
                }}
              ></img>
            ) : (
              <div
                className="aspect-video bg-zinc-100 w-full border-4 border-transparent flex flex-col items-center justify-center"
                style={{
                  border: selected
                    ? "3px solid rgba(62, 131, 246, 1)"
                    : "1px solid #E1E1E1",
                }}
              >
                <SvgLogo width="80" className="fill-neutral-400 mb-3 w-14" />
              </div>
            )}
            <div
              style={{
                cursor: "default",
                position: "absolute",
                bottom: "6px",
                left: "4px",
                textAlign: "center",
                borderRadius: "4px",
                height: "25px",
                padding: "0px 4px",
                backgroundColor: homePreset
                  ? "rgba(220, 231, 253, 1)"
                  : "rgba(34, 34, 34, 0.72)",
                color: homePreset ? "rgba(62, 131, 246, 1)" : "white",
              }}
            >
              {homePreset ? "Home Preset" : preset.name}
            </div>
          </div>
        );
      })}
    </div>
  );
}
